import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-mobile-kebab-menu',
    templateUrl: './mobile-kebab-menu.component.svg',
    styleUrls: ['./mobile-kebab-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileKebabMenuComponent {}
